import { Inbox } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

type NoDataProps = {
  description?: string;
};

function NoData(props: NoDataProps) {
  const { t } = useTranslation();
  const { description } = props;

  return (
    <Alert className="mt-4 max-w-xl">
      <Inbox className="size-8" />
      <AlertTitle>{t("empty.noDisplayData")}</AlertTitle>
      {description && <AlertDescription>{description}</AlertDescription>}
    </Alert>
  );
}

export { NoData };
